import styled, { css } from 'styled-components';
import { Heading, Button, mediaMixin, spaceMixin } from '@zillow/constellation';
import PropTypes from 'prop-types';

export const StyledHelp = styled(Heading)`
    padding-top: ${spaceMixin('xs')};
    padding-bottom: ${spaceMixin('sm')};
    ${mediaMixin(
        'md',
        css`
            padding-top: ${spaceMixin('md')};
            padding-bottom: ${spaceMixin('md')};
        `
    )}
    text-align: center;
`;
const StyledCallToActionWrapper = styled.div`
    display: block;
    margin: 0 auto;
    max-width: 240px;
`;
const StyledUpsellGroup = styled.div`
    text-align: center;
    padding: 0 ${spaceMixin('md')};
`;
const UpsellGroup = ({ text, href, onCTA, ctaText, className, inverse }) => (
    <StyledUpsellGroup className={className}>
        <StyledHelp level="5">{text}</StyledHelp>
        <StyledCallToActionWrapper>
            <Button as="a" href={href} onClick={onCTA} buttonType="primary" inverse={inverse} fluid>
                {ctaText}
            </Button>
        </StyledCallToActionWrapper>
    </StyledUpsellGroup>
);
UpsellGroup.propTypes = {
    className: PropTypes.string,
    text: PropTypes.string,
    onCTA: PropTypes.func,
    ctaText: PropTypes.string,
    inverse: PropTypes.bool,
    href: PropTypes.string,
};
UpsellGroup.defaultProps = {
    ctaText: 'Start here',
    href: '/get-started/',
};
export { StyledUpsellGroup };
export default UpsellGroup;
